import { authApiCall } from '../../auth/saga';

export const getMembershipPlans = () =>
  authApiCall({
    url: '/subscription/available-plans/',
    method: 'get',
  });
